import React, { Component } from 'react';
import './css/Account.css';
import { IconButton } from '../components/IconButton';
import { cmsAccount, jsonHeaders, msHeaders } from '../components/NavMenu';

export class Manufacture extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: {},
            companies: [],
            tab: "Company",
            models: []
        };
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                this.setState({ account: cmsAccount })
                this.fetchCompany();
                this.fetchModel();
                clearInterval(intervalId);
            }
        }, 100);
    }

    fetchCompany() {
        var requestOptions = {
            method: 'GET',
            headers: msHeaders,
            redirect: 'follow'
        };
        fetch(`/api/company/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.setState({ companies: result });
            })
    }

    addCompany() {
        const name = prompt("Please enter company's name.");
        if (name == null)
            return;

        const admin = prompt("Please enter admin's email.");
        if (admin == null)
            return;

        const contact = prompt("Please enter contact's email.");
        if (contact == null)
            return;

        const { account } = this.state;

        var requestOptions = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
                name: name,
                creater: account.username,
                admin: admin,
                contact: contact
            }),
            redirect: 'follow'
        };
        fetch(`/api/company/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchCompany();
            })
    }

    deleteCompany(name) {
        console.log(name)
        fetch(`/api/company/${name}`, { method: 'DELETE' })
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchCompany();
            })
    }

    updateCompany(companyName, property, value) {
        console.log(companyName, property, value)
        const raw = {}
        raw[property] = value;
        var requestOptions = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(raw),
            redirect: 'follow'
        };
        fetch(`/api/company/${companyName}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
            })
    }


    fetchModel() {
        var requestOptions = {
            method: 'GET',
            headers: msHeaders,
            redirect: 'follow'
        };
        fetch(`/api/models/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.setState({ models: result });
            })
    }

    addModel() {
        const name = prompt("Please enter model's name.");
        const size = Number(prompt("Please enter model's size."));
        const orientation = Number(prompt("Please enter model's orientation(0 or 90)."));
        if (name == null || size == null || orientation == null || (orientation != 0 && orientation != 90)) {
            alert("One or mroe fields error.")
            return;
        }

        var requestOptions = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
                name: name,
                size: size,
                orientation: orientation
            }),
            redirect: 'follow'
        };
        fetch(`/api/model/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchModel();
            })
    }

    deleteModel(uuid) {
        fetch(`/api/model/${uuid}`, { method: 'DELETE' })
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchModel();
            })
    }

    render() {
        const { account, tab, companies, models } = this.state;
        return (
            <>
                <div className='account-page'>
                    <div className='tab-container'>
                        <button onClick={() => { this.setState({ tab: "Company" }) }}>
                            Company
                        </button>
                        <button onClick={() => { this.setState({ tab: "Model" }) }}>
                            Model
                        </button>
                    </div>
                    <div style={tab == "Company" ? {} : { display: "none" }}>
                        <div className='user-table'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Company</th>
                                        <th>Admin</th>
                                        <th>Creater</th>
                                        <th>Contact</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {companies.map((company) => {
                                        return (
                                            <tr className='header' key={company.uuid}>
                                                <td>{company.name}</td>
                                                <td>
                                                    <input
                                                        type="text" className="form-control"
                                                        defaultValue={company.admin}
                                                        onBlur={(e) => { this.updateCompany(company.name, "admin", e.target.value) }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text" className="form-control"
                                                        defaultValue={company.creater}
                                                        onBlur={(e) => { this.updateCompany(company.name, "creater", e.target.value) }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text" className="form-control"
                                                        defaultValue={company.contact}
                                                        onBlur={(e) => { this.updateCompany(company.name, "contact", e.target.value) }}
                                                    />
                                                </td>
                                                <td style={{ display: "flex", gap: "10px" }}>
                                                    <IconButton
                                                        src={"icons/delete.svg"}
                                                        srcWhite={"icons/delete-white.svg"}
                                                        onClick={() => { this.deleteCompany(company.name) }}
                                                    />
                                                    <IconButton
                                                        src={"icons/mail.svg"}
                                                        srcWhite={"icons/mail-white.svg"}
                                                        onClick={() => { }}
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <button onClick={() => { this.addCompany() }}>add company</button>
                        </div>
                    </div>
                    <div style={tab == "Model" ? {} : { display: "none" }}>
                        <div className='user-table'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Model</th>
                                        <th>Size</th>
                                        <th>Orientation</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {models.map((model) => {
                                        return (
                                            <tr className='header' key={model.uuid}>
                                                <td>{model.name}</td>
                                                <td>{model.size}</td>
                                                <td>{model.orientation}</td>
                                                <td>
                                                    <IconButton
                                                        src={"icons/delete.svg"}
                                                        srcWhite={"icons/delete-white.svg"}
                                                        onClick={() => { this.deleteModel(model.uuid) }}
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <button onClick={() => { this.addModel() }}>add model</button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}